function handleTextFormat() {
  return () => true
}

export default handleTextFormat
